export const wrapperIdentifier = 'productCreator';

export interface ProductDefinition {
  identifier: string;
  name: string;
}
